'use client';

import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import BrandPanel from './BrandPanel';

export default function AuthPageClient() {
  const [activeTab, setActiveTab] = useState<'login' | 'register'>('login');

  return (
    <div className="min-h-screen flex bg-[#F8FAFB]">
      {/* Left brand panel — hidden on mobile */}
      <div className="hidden lg:flex lg:w-[52%] xl:w-[55%] flex-col">
        <BrandPanel />
      </div>

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center min-h-screen px-6 py-10 lg:px-12 xl:px-16">
        {/* Mobile logo */}
        <div className="lg:hidden mb-8 flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#0F6B5E] flex items-center justify-center">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M11 3C7.5 3 5 6 5 9.5C5 13.5 8 17 11 19C14 17 17 13.5 17 9.5C17 6 14.5 3 11 3Z" fill="white" opacity="0.9"/>
              <circle cx="11" cy="9.5" r="3" fill="white"/>
            </svg>
          </div>
          <span className="font-bold text-xl text-[#0F6B5E] tracking-tight">Waell</span>
        </div>

        <div className="w-full max-w-md">
          {/* Tab switcher */}
          <div className="flex bg-white border border-[hsl(var(--border))] rounded-2xl p-1 mb-8 shadow-sm">
            <button
              onClick={() => setActiveTab('login')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === 'login' ?'bg-[#0F6B5E] text-white shadow-sm' :'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]'
              }`}
            >
              Sign in
            </button>
            <button
              onClick={() => setActiveTab('register')}
              className={`flex-1 py-2.5 rounded-xl text-sm font-semibold transition-all duration-200 ${
                activeTab === 'register' ?'bg-[#0F6B5E] text-white shadow-sm' :'text-[hsl(var(--muted-foreground))] hover:text-[hsl(var(--foreground))]'
              }`}
            >
              Create account
            </button>
          </div>

          {/* Form */}
          <div className="animate-slide-up">
            {activeTab === 'login' ? (
              <LoginForm onSwitchToRegister={() => setActiveTab('register')} />
            ) : (
              <RegisterForm onSwitchToLogin={() => setActiveTab('login')} />
            )}
          </div>

          {/* Trust footer */}
          <div className="mt-8 flex items-center justify-center gap-6 flex-wrap">
            <div className="flex items-center gap-1.5 text-xs text-[hsl(var(--muted-foreground))]">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 1L2 3.5V7C2 9.8 4.2 12.4 7 13C9.8 12.4 12 9.8 12 7V3.5L7 1Z" stroke="#0F6B5E" strokeWidth="1.2" fill="none"/>
                <path d="M5 7l1.5 1.5L9 5.5" stroke="#0F6B5E" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
              <span>GDPR/AVG compliant</span>
            </div>
            <div className="flex items-center gap-1.5 text-xs text-[hsl(var(--muted-foreground))]">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <rect x="2" y="6" width="10" height="7" rx="1.5" stroke="#0F6B5E" strokeWidth="1.2" fill="none"/>
                <path d="M4.5 6V4.5a2.5 2.5 0 015 0V6" stroke="#0F6B5E" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
              <span>NEN 7510 security</span>
            </div>
            <div className="flex items-center gap-1.5 text-xs text-[hsl(var(--muted-foreground))]">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="7" r="5" stroke="#0F6B5E" strokeWidth="1.2" fill="none"/>
                <path d="M5 7l1.5 1.5L9.5 5" stroke="#0F6B5E" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
              <span>BIG-registered doctors</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}